var locale = {
    placeholder: 'Select time'
};
export default locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/time-picker/locale/en_US.js
// module id = 169
// module chunks = 1